import { create } from "zustand";
import { MenuItem } from "@/core/types/menuApi";
interface DrawerState {
  primaryOpen: boolean;
  secondaryOpen: boolean;
  selectedItemId: number | null;
  setPrimaryOpen: (open: boolean) => void;
  setSecondaryOpen: (open: boolean) => void;
  setSelectedItemId: (id: number | null) => void;
}

export const useDrawerStore = create<DrawerState>((set) => ({
  primaryOpen: false,
  secondaryOpen: false,
  selectedItemId: null,
  setPrimaryOpen: (open) => set({ primaryOpen: open }),
  setSecondaryOpen: (open) => set({ secondaryOpen: open }),
  setSelectedItemId: (id) => set({ selectedItemId: id }),
}));



type DrawerStoreTolica = {
  open: boolean;
  stack: MenuItem[];
  setOpen: (open: boolean) => void;
  push: (item: MenuItem) => void;
  pop: () => void;
  reset: () => void;
};

export const useDrawerStoreTolica = create<DrawerStoreTolica>(set => ({
  open: false,
  stack: [],
  setOpen: open => set({ open, stack: open ? [] : [] }),
  push: item => set(s => ({ stack: [...s.stack, item] })),
  pop: () => set(s => ({ stack: s.stack.slice(0, -1) })),
  reset: () => set({ open: false, stack: [] }),
}));